import { createElement, Sun, Moon } from 'lucide';
import type { UnifiedGridVisualizer } from './visualizer';

/**
 * Toggle between light and dark theme
 */
export function toggleTheme(unifiedVisualizer: UnifiedGridVisualizer | null): void {
  const html = document.documentElement;
  const currentTheme = html.getAttribute('data-theme');
  const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

  html.setAttribute('data-theme', newTheme);
  localStorage.setItem('genmus-theme', newTheme);

  // Update icon
  const themeEl = document.getElementById('icon-theme');
  if (themeEl) {
    themeEl.innerHTML = '';
    const iconAttrs = { 'stroke-width': 1.5, width: 16, height: 16 };
    themeEl.appendChild(createElement(newTheme === 'dark' ? Sun : Moon, iconAttrs));
  }

  // Update visualizer colors
  if (unifiedVisualizer) {
    unifiedVisualizer.updateColors();
  }
}
